import React from "react";
import classNames from "classnames";
import bind from "memoize-bind";
import CSSModules from "lib/utils/css-modules";

import { FormControl } from "lib/index";
import styles from "./FilterGroup.less";

@CSSModules(styles)
export default class FilterGroup extends React.PureComponent {
  constructor(...args) {
    super(...args);
    const { enabled, defaultActive = enabled, active = defaultActive } = this.props;
    this.state = {
      active,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.enabled !== this.props.enabled && nextProps.enabled) {
      this.setState({ active: nextProps.enabled });
    }
  }

  handleClear(event) {
    event.stopPropagation();
    this.props.onClear();
    this.setState({ active: false });
  }

  handleTitleClick() {
    this.handlesActiveState && this.setState({ active: !this.state.active });
  }

  get handlesActiveState() {
    return this.props.active === undefined;
  }

  render() {
    const { label, enabled, children, active = this.state.active } = this.props;
    return (
      <div styleName="filter-group" className={classNames({ active, enabled })}>
        {label && (
          <div
            styleName="filter-group-title"
            onClick={bind(this.handleTitleClick, this)}
            style={{ cursor: this.handlesActiveState ? "pointer" : "default" }}
          >
            {label}
            &nbsp;
            {this.handlesActiveState && <i className="icon dropdown" />}
            {enabled && (
              <FormControl.DeleteRowButton
                styleName="delete-button"
                innerAlign="center"
                onClick={bind(this.handleClear, this)}
              />
            )}
          </div>
        )}
        <div styleName="filter-group-content" hidden={!active}>
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FilterGroup.jsx